import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-5 items-center md:h-screen mt-5 md:mt-0" }
const _hoisted_2 = { class: "w-full sm:w-auto lg:w-full" }
const _hoisted_3 = { class: "bg-white shadow-md rounded-xl overflow-hidden lg:m-10" }
const _hoisted_4 = { class: "bg-gray-50 p-5 border-b" }
const _hoisted_5 = { class: "px-5 py-5" }
const _hoisted_6 = { class: "flex flex-col my-4" }
const _hoisted_7 = { class: "flex flex-col my-4" }
const _hoisted_8 = { class: "flex justify-between flex-col md:flex-row text-center gap-5" }
const _hoisted_9 = { class: "field-checkbox flex gap-2 items-center" }
const _hoisted_10 = { for: "binary" }
const _hoisted_11 = { class: "mt-5" }
const _hoisted_12 = { class: "bg-gray-50 p-4 flex justify-end items-center mt-3 border-t border-t-gray-300 rounded-b-lg" }
const _hoisted_13 = { class: "hidden lg:flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Errors = _resolveComponent("Errors")!
  const _component_InputPassword = _resolveComponent("InputPassword")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ComputerComponent = _resolveComponent("ComputerComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t("auth.login.title")), 1)
        ]),
        _createElementVNode("form", {
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.loginUser()), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_InputText, {
                id: "username-input",
                type: "text",
                modelValue: _ctx.form.username,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.username) = $event)),
                placeholder: _ctx.$t('auth.login.email'),
                class: _normalizeClass(_ctx.v$.form.username.$error ? 'p-invalid' : '')
              }, null, 8, ["modelValue", "placeholder", "class"]),
              _createVNode(_component_Errors, {
                errors: _ctx.v$.form.username.$errors
              }, null, 8, ["errors"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_InputPassword, {
                id: "password-input",
                modelValue: _ctx.form.password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.password) = $event)),
                feedback: false,
                toggleMask: "",
                placeholder: _ctx.$t('auth.login.password'),
                class: _normalizeClass(_ctx.v$.form.password.$error ? 'p-invalid' : '')
              }, null, 8, ["modelValue", "placeholder", "class"]),
              _createVNode(_component_Errors, {
                errors: _ctx.v$.form.password.$errors
              }, null, 8, ["errors"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_Checkbox, {
                  inputId: "binary",
                  modelValue: _ctx.isRemember,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isRemember) = $event)),
                  binary: true
                }, null, 8, ["modelValue"]),
                _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("auth.login.keep")), 1)
              ]),
              _createElementVNode("a", {
                id: "forgot-password-link",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.go.redirectTo('forgot-password'))),
                class: "text-sm font-[700] text-h-primary-500 hover:text-h-primary-700 cursor-pointer"
              }, _toDisplayString(_ctx.$t("auth.login.forgot")), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createTextVNode(_toDisplayString(_ctx.$t("auth.login.register")) + " ", 1),
              _createVNode(_component_RouterLink, {
                to: "/signup",
                class: "text-h-primary-500"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("auth.login.link")), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_Button, {
              type: "submit",
              label: _ctx.$t('labels.enter'),
              class: "btn-primary"
            }, null, 8, ["label"])
          ])
        ], 32)
      ])
    ]),
    _createElementVNode("section", _hoisted_13, [
      _createVNode(_component_ComputerComponent)
    ])
  ]))
}